import { metrics } from '@atlassian/browser-metrics';

export const projectSettingsAccessPagePageLoad = metrics.pageLoad({
	key: 'project-settings.access',
});

export const addPeopleMetrics = metrics.interaction({
	key: 'project-settings.add-people',
});

export const customRoleInteractionMetrics = metrics.interaction({
	key: 'project-settings.custom-roles',
});
